import {defineSlotRecipe} from '@chakra-ui/react3'

export const MODULE_CONTAINER_MAP = {
    'true|default': {modulePadding: 'none', spacing: 'none'},
    'true|reduced': {modulePadding: 'none', spacing: 'none'},
    'true|min': {modulePadding: 'none', spacing: 'none'},
    'true|min-top': {modulePadding: 'none', spacing: 'none'},
    'true|min-bottom': {modulePadding: 'none', spacing: 'none'},
    'true|none': {modulePadding: 'none', spacing: 'none'},
    'true|undefined': {modulePadding: 'none', spacing: 'none'},

    'false|default': {modulePadding: 'awards', spacing: 'default'},
    'false|reduced': {modulePadding: 'awards', spacing: 'reduced'},
    'false|min': {modulePadding: 'awards', spacing: 'min'},
    'false|min-top': {modulePadding: 'awards', spacing: 'min-top'},
    'false|min-bottom': {modulePadding: 'awards', spacing: 'min-bottom'},
    'false|none': {modulePadding: 'awards', spacing: 'none'},
    'false|undefined': {modulePadding: 'awards'}
}

/**
 * recipe for Awards
 */

export default defineSlotRecipe({
    slots: [
        'root',
        'backgroundLayer',
        'backgroundImage',
        'content',
        'awardsGroup',
        'award',
        'awardImage',
        'awardText',
        'copy'
    ],
    base: {
        root: {
            position: 'relative',
            width: '100%'
        },
        backgroundImage: {
            width: '100%',
            height: 'auto'
        },
        content: {
            position: 'relative',
            zIndex: 1,
            maxWidth: {s: '8/12'},
            marginX: 'auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 'spacing-32'
        },
        awardsGroup: {
            display: 'flex',
            flexDirection: 'row',
            paddingTop: {base: 'spacing-16', s: 'spacing-48'},
            paddingX: {base: 'spacing-16', s: 'spacing-64'},
            gap: {base: 'spacing-16', s: 'spacing-48'}
        },
        award: {
            display: 'grid',
            gridTemplateRows: {
                base: '6.75rem auto',
                s: '8.7rem auto'
            },
            justifyItems: 'center',
            gap: 'spacing-24',
            paddingX: {base: 'spacing-16', s: 'spacing-32'},
            '&:nth-of-type(3)': {display: {base: 'none', s: 'grid'}},
            '&:nth-of-type(n+4)': {display: 'none'}
        },

        awardImage: {
            height: '100%',
            objectFit: 'contain'
        },

        awardText: {
            textAlign: 'center',
            textStyle: 'body.small',
            maxWidth: '12rem',
            wordBreak: 'break-word'
        },
        copy: {
            textAlign: 'center'
        }
    },
    variants: {
        copySize: {
            default: {
                copy: {textStyle: 'display.xsmall'}
            },
            emphasized: {
                copy: {textStyle: 'display.medium'}
            }
        },
        hasBackground: {
            true: {
                root: {
                    display: 'grid',
                    gridTemplateColumns: 'minmax(0, 1fr)',
                    width: '100%',
                    maxWidth: '100%',
                    overflow: 'hidden'
                },
                backgroundLayer: {
                    gridArea: '1 / 1 / 2 / 2',
                    display: 'grid',
                    position: 'relative',
                    width: '100%',
                    maxWidth: '100%',
                    minWidth: 0,
                    overflow: 'hidden',
                    zIndex: 0,
                    pointerEvents: 'none'
                },
                backgroundImage: {
                    display: 'block',
                    width: '100%',
                    height: 'auto',
                    minHeight: '100%',
                    objectFit: 'cover'
                },
                content: {
                    gridArea: '1 / 1 / 2 / 2',
                    alignSelf: 'center',
                    justifySelf: 'center',
                    width: '100%',
                    maxWidth: '100%',
                    minWidth: 0,
                    paddingTop: {base: 'spacing-64', s: 'spacing-128'},
                    paddingBottom: {base: 'spacing-40', s: 'spacing-128'},
                    paddingInline: {base: 'spacing-24', s: 'spacing-128'}
                },
                awardsGroup: {
                    paddingX: {base: 'spacing-0', s: 'spacing-64'}
                }
            },
            false: {}
        }
    },
    defaultVariants: {
        copySize: 'default',
        hasBackground: false
    }
})
